export function authUserId() {
    return document.querySelector('meta[name="user-id"]').content;

}

